import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import "react-phone-input-2/lib/bootstrap.css";
import {
  createUser,
  updateUser,
  getSingleUser,
  getAllCorporationIds,
  getAllOrgnaizationIds,
} from "../Api/ApiCalls";
import LoadingSpinner from "../common/Loading";
import { userValidationSchema } from "../common/Validation";
import log from "../core/log";

export const CreateUser = () => {
  const formOptions = { resolver: yupResolver(userValidationSchema) };
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [toasting, setToasting] = useState(false);
  const [corporationIds, setCorporationIds] = useState([]);
  const [organizationIdsAndName, setOrganizationIdsAndName] = useState([]);
  const location = useLocation();
  const { id, corp_code, org_code } = location.state || "";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm(formOptions);

  const getCorporationsIds = async () => {
    try {
      setLoading(true);
      const data = await getAllCorporationIds();
      if (data) {
        setCorporationIds(data);
      }
      setLoading(false);
    } catch (err) {
      log(`Error while fetching corporation id's: `, err);
      setLoading(false);
    }
  };
  const getOrganizationIds = async (id) => {
    try {
      setLoading(true);
      const data = await getAllOrgnaizationIds(id);
      if (data) {
        setOrganizationIdsAndName(data);
        reset({ organization_code: "" });
      }
      setLoading(false);
    } catch (err) {
      log(`Error while fetching organizations id's: `, err);
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    if (!userData) {
      try {
        delete data.id;
        const result = await createUser(data);
        if (result.status) {
          toast.success("User created successfully");
          resetFields(data);
        } else {
          toast.info("User already exists at this phone number");
          reset({ ...data, phone_number: "" });
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
        log("Error while creating user ", err);
        setLoading(false);
      }
    } else {
      try {
        delete data.id;
        await updateUser({ id: userData.id, payload: data });

        toast.success("User Updated successfully", {
          toastId: "update",
          onClose: () => {
            setToasting(false);
          },
          onOpen: () => {
            setToasting(true);
          },
        });
        setLoading(false);
      } catch (err) {
        console.log(err);
        log("Error while updating user data ", err);
        setLoading(false);
      }
    }
  };

  const resetFields = (data) => {
    if (!data || !Object.keys(data).length) return;
    const tempObj = {};
    Object.keys(data).forEach((field) => {
      tempObj[field] = field === "country_code" ? "+91" : "";
    });
    reset(tempObj);
  };

  const getUserData = async () => {
    setLoading(true);
    try {
      const result = await getSingleUser(id, corp_code, org_code);
      if (result.status) {
        setUserData(result.data);
        reset(result.data);
        phoneNumberValidate(String(result?.data?.phone_number || ""));
      } else {
        toast.info(result.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while fetching organization data ", err);
      setLoading(false);
    }
  };

  const organizationFetch = (corporationCode) => {
    if (corporationCode) {
      getOrganizationIds(corporationCode);
    } else {
      setOrganizationIdsAndName([]);
    }
  };

  useEffect(() => {
    if (id) {
      getUserData();
    } else {
      resetFields(userData);
      setUserData();
      getCorporationsIds();
    }
  }, [location]);

  const phoneNumberValidate = (phone_number) => {
    if (phone_number) {
      const code = getValues("country_code");
      if (code === "+1") {
        const phone = phone_number.replace(
          /\D*(\d{3})\D*(\d{3})\D*(\d{4})\D*/,
          "$1 $2 $3"
        );
        setValue("phone_number", phone);
      } else if (code === "+91") {
        const phone = phone_number.replace(/(\d{5})\D*(\d{5})/, "$1 $2");
        setValue("phone_number", phone);
      }
    }
  };

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-10">
            <form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="text-4xl text-[#96BF61] font-bold">
                {id ? "Edit Customer Admin" : "Create Customer Admin"}
              </h2>

              {loading && <LoadingSpinner />}
              <div className="grid grid-cols-12 mt-5">
                <div className="col-span-12 lg:col-span-12">
                  <div className=" shadow-md rounded">
                    <div className="bg-white rounded-[21px] p-10 mt-6">
                      <div className="">
                        <div className="flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.corporation_code?.message}
                            </span>
                            <label
                              htmlFor="corporation_code"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Corporation code
                              <span className="text-red-600">*</span>
                            </label>
                            {!id ? (
                              <>
                                <select
                                  {...register("corporation_code", {
                                    onChange: (e) => {
                                      organizationFetch(e.target.value);
                                    },
                                  })}
                                  className="py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md "
                                >
                                  <option value={""}>Select a code</option>
                                  {corporationIds &&
                                    corporationIds.length &&
                                    corporationIds.map((val, index) => {
                                      return (
                                        <option key={index} value={val.id}>
                                          {val.id}
                                        </option>
                                      );
                                    })}
                                </select>
                                <div className="absolute right-2 top-[52px] pointer-events-none">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                      fill="#1D192B"
                                    ></path>
                                  </svg>
                                </div>
                              </>
                            ) : (
                              <input
                                id="corporation_code"
                                className={`py-3 block shadow-md w-full px-4 mt-0  ${
                                  id ? "bg-gray-300" : "bg-white"
                                } border border-b-2 appearance-none w-full focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                                disabled={id}
                                value={corp_code}
                                placeholder="Corporation code"
                              />
                            )}
                          </div>
                          <div className="flex-auto mx-4 w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.organization_code?.message}
                            </span>

                            <label
                              htmlFor="organization_code"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Organization code
                              <span className="text-red-600">*</span>
                            </label>
                            {!id ? (
                              <>
                                <select
                                  id="organization_code"
                                  {...register("organization_code")}
                                  className="py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                                >
                                  <option value={""}>Select a code</option>
                                  {organizationIdsAndName &&
                                    organizationIdsAndName.length &&
                                    organizationIdsAndName.map((val, index) => {
                                      return (
                                        <option key={index} value={val.id}>
                                          {val.id} &nbsp;&nbsp; {val.name}
                                        </option>
                                      );
                                    })}
                                </select>
                                <div className="absolute right-2 top-[52px] pointer-events-none">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                      fill="#1D192B"
                                    ></path>
                                  </svg>
                                </div>
                              </>
                            ) : (
                              <input
                                id="corporation_code"
                                className={`py-3 block shadow-md w-full px-4 mt-0  ${
                                  id ? "bg-gray-300" : "bg-white"
                                } border border-b-2 appearance-none w-full focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                                disabled={id}
                                value={org_code}
                                placeholder="Corporation code"
                              />
                            )}
                          </div>
                          <div className="flex-auto w-1/3 relative">
                            <label
                              htmlFor="user_name"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Customer Admin Name
                              <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.user_name?.message}
                            </span>
                            <input
                              id="user_name"
                              type="text"
                              {...register("user_name", {
                                required: true,
                              })}
                              className="py-3 bg-white shadow-md block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              placeholder="Enter Customer Admin Name"
                            />
                          </div>
                        </div>
                        <div className="mt-5 flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <label
                              htmlFor="email_address"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Email Address
                              <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.email_address?.message}
                            </span>
                            <input
                              id="email_address"
                              type="text"
                              {...register("email_address", {
                                required: true,
                              })}
                              className={`py-3 bg-white shadow-md block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                              placeholder="Enter Email Address"
                            />
                          </div>
                          <div className="flex-auto mx-4 w-1/3 relative">
                            <label
                              htmlFor="phone_number"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Phone Number
                              <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.phone_number?.message}
                            </span>
                            <div className="flex justify-between relative">
                              <>
                                <select
                                  className={`form-control ${
                                    id ? "bg-gray-300" : "bg-transparent"
                                  } w-1/5 border rounded-md shadow-md py-[14px] px-3 border border-black-300 outline-none`}
                                  {...register("country_code", {
                                    onChange: () => {
                                      setValue("phone_number", "");
                                    },
                                  })}
                                  disabled={id}
                                >
                                  <option value="+1">+1</option>
                                  <option value="+91">+91</option>
                                </select>
                                <div className="absolute left-10 top-4 pointer-events-none">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                      fill="#1D192B"
                                    ></path>
                                  </svg>
                                </div>
                              </>

                              <input
                                className={`${
                                  id ? "bg-gray-300" : "bg-white"
                                }  py-3  shadow-md block w-4/5 px-4 mt-0  border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                                placeholder="Enter Phone Number"
                                disabled={userData}
                                {...register("phone_number", {
                                  onChange: (e) => {
                                    phoneNumberValidate(e.target.value);
                                  },
                                })}
                              />
                            </div>
                          </div>
                          <div className="flex-auto w-1/3 relative">
                            <label
                              htmlFor="phone_number"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Status
                              <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.status?.message}
                            </span>
                            <>
                              <select
                                id="status"
                                {...register("status")}
                                className="py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              >
                                <option value="">Select a status</option>
                                <option value="active">Active</option>
                                <option value="inactive">In Active</option>
                              </select>
                              <div className="absolute right-2 top-[52px] pointer-events-none">
                                <svg width="20" height="20" viewBox="0 0 24 24">
                                  <path
                                    d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                    fill="#1D192B"
                                  ></path>
                                </svg>
                              </div>
                            </>
                          </div>
                        </div>
                        <div className="pt-12 text-right">
                          <button
                            type="form"
                            disabled={toasting}
                            className="px-8 py-2 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none font-semibold bg-[#024C85] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                          >
                            {userData ? "Update Customer Admin" : "Add Customer Admin"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
